export enum BoardingStateEnum {
  Boarded = "Boarded",
  NotBoarded = "NotBoarded",
  Unknown = "Unknown",
}
